namespace GeniuzPOS.AdvPromo {
    export namespace PsPromoAvMbService {
        export const baseUrl = 'AdvPromo/PsPromoAvMb';

        export declare function Create(request: Serenity.SaveRequest<PsPromoAvMbRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoAvMbRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoAvMbRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoAvMbRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsPromoAvMb/Create",
            Update = "AdvPromo/PsPromoAvMb/Update",
            Delete = "AdvPromo/PsPromoAvMb/Delete",
            Retrieve = "AdvPromo/PsPromoAvMb/Retrieve",
            List = "AdvPromo/PsPromoAvMb/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoAvMbService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
